module.exports = __webpack_public_path__ + "media/referral/productBooks-b8477477.png";